import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=6cb17000&scoped=true"
import script from "./RoleItem.vue?vue&type=script&lang=js"
export * from "./RoleItem.vue?vue&type=script&lang=js"
import style0 from "./RoleItem.vue?vue&type=style&index=0&id=6cb17000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb17000",
  null
  
)

export default component.exports